export const homeHeroSectionStyleProps = {
    backgroundColor: 'primary.default',
    bgGradient: 'linear(to-b, primary.default, primary.400)',
    height: {base: '32rem', tablet: '44rem'},
    maxHeight: {base: '32.5rem', tablet: '44rem'},
    minHeight: {base: '27.5rem', tablet: '44rem'},
    position: 'relative',
};

export const homeHeroBackgroundStyleProps = {
    content: `""`,
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
};

export const homeHeroIconCircleStyleProps = {
    width: {base: 14, tablet: 16},
    height: {base: 14, tablet: 16},
    background: 'rgba(255, 255, 255, 0.15)',
    borderRadius: '100%',
    position: 'relative',
};

export const homeHeroIconStyleProps = {
    color: 'white',
    height: {base: 9, tablet: 10},
    width: {base: 9, tablet: 10},
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
};

export const HomeHeroHeadlineContainerStyleProps = {
    marginY: 4,
};

export const homeHeroH1StyleProps = {
    as: 'h1',
    color: 'white',
    marginY: 0,
    textAlign: 'center',
};

export const homeHeroH2StyleProps = {
    as: 'h2',
    variant: 'h3',
    color: 'white',
    marginTop: 2,
    fontWeight: 'normal',
    textAlign: 'center',
};
